import { NewColorScheme } from '../default/Colors';
import { useMemo, useState } from 'react';
import type { VennColors } from '../../style/color';
import { transformCustomColorsToVennColors, type CustomColors } from '../../style/customColors';

export const useColorTheme = () => {
  const [customColors, setCustomColors] = useState<CustomColors | undefined>(undefined);
  const [debugColors, setDebugColors] = useState<VennColors | undefined>(undefined);

  const colors = useMemo(
    () => (customColors ? transformCustomColorsToVennColors(NewColorScheme, customColors) : NewColorScheme),
    [customColors],
  );

  return { colors: debugColors ?? colors, customColors, setCustomColors, setDebugColors } as const;
};
